import React from "react";
import { Divider, Header } from "semantic-ui-react";

import "./FormHeader.scss";

interface IFormHeaderProps {
  title: string;
  color: string;
  icon: JSX.Element;
  showDivider?: boolean;
  spaceBetween?: boolean;
  subHeader?: string;
}

export default function FormHeader({
  children,
  title,
  color,
  icon,
  spaceBetween = false,
  showDivider = true,
  subHeader,
}: React.PropsWithChildren<IFormHeaderProps>) {
  return (
    <>
      <div className='form-header'>
        <div className='left-container'>
          <div className='icon-circle' style={{ backgroundColor: color }}>
            {icon}
          </div>
          <Header>
            <Header.Content>{title}</Header.Content>
            {subHeader && <Header.Subheader>{subHeader}</Header.Subheader>}
          </Header>
        </div>
        <div className='right-container'>{children}</div>
      </div>
      {showDivider && <Divider />}
      {spaceBetween && <div style={{ height: 16 }} />}
    </>
  );
}
